import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './editContact.scss';
import AddWhiteIcon from '@/assets/steam/add-white.png';
import CloseIcon from '@/assets/steam/close.svg'
import { showNotification } from '@/utils/notificationUtils';
import DatePicker, { DayValue, DayRange, Day } from 'react-modern-calendar-datepicker';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from 'moment';
import { useAuth } from '@/lib/auth';
import Utils from '@/utils/util';
import { User } from '@/types';
import 'react-phone-input-2/lib/style.css'; // You may need to import the stylesheet as well
import PhoneInput from 'react-phone-input-2';
import { default as ReactSelect, components } from 'react-select';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import { City, State } from '../types/indes';
import Dropdown from 'react-bootstrap/Dropdown';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useUpdateContact } from '../api/updateContact';
import { ModalFooter } from 'react-bootstrap';
import { useDeleteCity } from '../api/deleteCity';
import { DESIGNATION_TYPES } from '@/utils/constants';

const EditContact: VFC<{
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
    states?: any;
    role?: any;
    editContactData?: any;
    instituteList?:any;
}> = ({ onClose, onConfirm, open, states, role, editContactData,instituteList }) => {
    const { user } = useAuth();
    const [selectedInstitute, setSelectedInstitute] = useState<any>()
    const [phone, setPhone] = useState('');
    const [cityData, setNewCityData] = useState<string>('');
    const useContactUpdateMutations = useUpdateContact();
    const [city, setCity] = useState<City[]>([]);
    const [newCityDetails, setNewCityDetails] = useState<any[]>([]);
    const [deletedCity, setDeletedCity] = useState<any[]>([]);
    const useDeleteCityMutation = useDeleteCity();
    const [userData, setUserData] = useState<User>({
        name: '',
        email: '',
        designation:'',
    } as User);

    useEffect(() => {
        if (editContactData) {

            setUserData({
                name: editContactData?.name,
                email: editContactData?.email,
                designation: editContactData?.designation,
            } as User)
            setSelectedInstitute(editContactData?.institute)

            setPhone(editContactData?.phone)

        }

    }, [editContactData])


    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.id === 'name') {
            userData.name = event.target.value;
        } else if (event.target.id === 'phone') {
            userData.phone = event.target.value;
        } else if (event.target.id === 'designation') {
            userData.designation = event.target.value;
        }
        
        setUserData({ ...userData });
    };
    const deleteCityId = async (id: any) => {
        const res = await useDeleteCityMutation.mutateAsync({
            id
        });
        if (res) {
            resetStates();
            onConfirm();
            // getLocationsList(1, true);
        }
    }



    const resetStates = () => {
        setCity([]);
        setPhone('')
       
        setNewCityData('');

    }

    const handleChangeEmail = async (event: ChangeEvent<HTMLInputElement>) => {
        userData.email = event.target.value;
        if (Utils.isValidEmail(userData?.email)) {
            setUserData({ ...userData });
        }
        setUserData({ ...userData });
    };

    const getContent = () => {
        return (
            <div className="add-location-content">
                <div className="user-container">
                    <h1>
                    Associated Institute <span>*</span>
                    </h1>
                    {/* <div className='user-first-last-div'>
                        <input
                            className={`custome-input`}
                            placeholder={'Institute name'}
                            onChange={handleChange}
                            value={editContactData?.institute?.name}
                            id="name"
                            disabled={true}
                        />
                    </div> */}
                    <div className="user-first-last-div iscity-drp petsked-form mt-2">
                    <Dropdown className="new-figma-drop-down">
                        <Dropdown.Toggle
                            variant="success"
                            className="drop-down-btn set-color dropdown-toggle"
                            id="dropdown-basic"
                        >
                            {selectedInstitute?.name ? selectedInstitute?.name : 'Select institute'}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="Duration-drop-down">
                            {instituteList?.map((item: any, index: any) => {
                                return (
                                    <Dropdown.Item
                                        key={index}
                                        onClick={() => {
                                            selectedInstitute.name = item.name;
                                            selectedInstitute.address = item.address
                                            selectedInstitute.gstNumber = item.gstNumber
                                            selectedInstitute.state = item.state
                                            selectedInstitute.city = item.city
                                            selectedInstitute.id = item.id
                                            setSelectedInstitute({ ...selectedInstitute })
                                        }}
                                        eventKey={item.name}
                                    >
                                        <div className="menu-item-minutes">{item.name}</div>
                                    </Dropdown.Item>
                                );
                            })}
                        </Dropdown.Menu>
                    </Dropdown>
                    </div>
                    <div className='user-first-last-div'>
                        <input
                            className={`custome-input`}
                            placeholder={'Institute address'}
                            onChange={handleChange}
                            value={selectedInstitute?.address}
                            id="name"
                            disabled={true}
                        />
                    </div>
                    {/* <div className="institute-description">
                        {editContactData?.institute?.address}
                        
                    </div> */}

                </div>

                <div className="user-container">
                    <h1>
                        Location Details <span>*</span>
                    </h1>
                    <div className='user-first-last-div'>
                        <input
                            className={`custome-input width-50`}
                            placeholder={'Name'}
                            onChange={handleChange}
                            value={selectedInstitute?.state?.name}
                            disabled={true}
                        />
                        <input
                            className={`custome-input width-50`}
                            placeholder={'Name'}
                            onChange={handleChange}
                            value={selectedInstitute?.city?.name}
                            id="name"
                            disabled={true}
                        />
                    </div>
                </div>

                <div className="user-container">

                    <div className='loctaion-title'>
                        <div className='title'>
                            <h2 className='mb-2'>
                                Contact Details<span>*</span>
                            </h2>
                        </div>
                        {editContactData?.isKeyPerson && <div className='addd-location is-primary'>
                            Primary
                        </div>}
                    </div>
                    <div className='user-first-last-div'>
                        <input
                            className={`custome-input width-50`}
                            placeholder={'Name'}
                            onChange={handleChange}
                            value={userData?.name}
                            id="name"
                        />
                        <div className="new-figma-phone">
                            <PhoneInput
                                placeholder="phone no"
                                value={phone}
                                onChange={setPhone}
                                country={'in'}
                                countryCodeEditable={false}
                            />
                        </div>
                    </div>
                    {/* <input
                        className={`custome-input`}
                        placeholder={'Designation'}
                        onChange={handleChange}
                        value={userData?.designation}
                        id="designation"
                    /> */}

<div className="user-first-last-div mt-2">
                                        <Dropdown className="new-figma-drop-down">
                                            <Dropdown.Toggle
                                                variant="success"
                                                className="drop-down-btn dropdown-togge"
                                                id="dropdown-basic"
                                            >
                                                {userData?.designation ? userData?.designation : 'Designation'}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="Duration-drop-down">
                                                {DESIGNATION_TYPES.map((itemProd: any, prodIndex: any) => {
                                                    return (
                                                        <Dropdown.Item
                                                            key={prodIndex}
                                                            onClick={() => {
                                                                userData.designation = itemProd;
                                                                setUserData({...userData})
                                                            }}
                                                            eventKey={itemProd}
                                                        >
                                                            <div className="menu-item-minutes">{itemProd}</div>
                                                        </Dropdown.Item>
                                                    );
                                                })}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                    <input
                        className={`custome-input`}
                        placeholder={'Email'}
                        onChange={handleChangeEmail}
                        value={userData?.email}
                        id="email"
                    />
                    <div className='note'>This email address will be used for further communication</div>
                </div>

            </div>
        );
    };
    return (
        <>
            <Modal
                show={open}
                onHide={() => { resetStates(), onClose() }}
                className={`steam-modal-dialog add-contact-modal `}
                size="sm"

            >
                <Modal.Header closeButton >
                    <div className="model-header-tab">
                        <div className="modal-header-title">
                            {editContactData ? "Edit contact" : 'Add new location'}
                        </div>
                        <div className="modal-header-desc">
                            {/* {'Lorem ipsum dolor sit amet, consectetur elit, sed'} */}
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body >{getContent()}</Modal.Body>
                <ModalFooter>
                    <div className={`btn-container end`}>
                        <button
                            className={`steam-button button-dark set-height`}
                            onClick={async () => {
                                await useContactUpdateMutations.mutateAsync({
                                    id: editContactData ? Number(editContactData?.id) : undefined,
                                    name: userData?.name,
                                    phone: phone?.startsWith('+') ? phone :`+${phone}`,
                                    email: userData?.email,
                                    instituteId : selectedInstitute?.id,
                                    designation: userData?.designation
                                });
                                onConfirm();

                            }}
                        //disabled={useAddInstituteMutation?.isLoading}
                        >
                            <span>{editContactData ? "Save" : 'Add User'}</span>
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
};




export default EditContact;
